// Copyright (c) 2022 by Move Closer

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const PRODUCTS_TEASER_COMPONENT_KEY = 'ProductsTeaserComponent'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const PRODUCTS_TEASER_DEFAULT_CONFIG = {
  carouselConfig: {
    autoplay: false,
    centralize: false,
    delay: 2000,
    hasPagination: false,
    hasButtons: true,
    initialSlide: 0,
    inLoop: false,
    pauseOnHover: false,
    responsive: {
      mobile: {
        perPage: 2,
        hasButtons: false
      },
      desktop: { perPage: 4 }
    }
  }
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 *
 */
export const PRODUCT_TEASER_AUTO_SKU_MARKER = '__PRODUCT[sku]__'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const GLOBAL_CONTAINER_WIDTH = {
  desktop: 1360,
  mobile: 940
}
